<template>
    <div>
        <el-button type="primary" size="mini" @click="showdialog = true; getTableData()">选择楼盘</el-button>
        <el-dialog
            title="项目列表"
            :visible.sync="showdialog"
            width="1200px"
            v-if="regions"
            append-to-body>

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="楼盘名称">
                            <el-input v-model="form.name" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="区域">
                            <el-cascader
                            v-model="form.region"
                            :options="regions"
                            clearable
                            :props="{label: 'label', value: 'label', children: 'children'}">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="价格区间">
                            <el-input type="number" v-model="form.price.min" placeholder="最低价格"></el-input>
                            <span>-</span>
                            <el-input type="number" v-model="form.price.max" placeholder="最高价格"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="楼盘名称" show-overflow-tooltip></el-table-column>
                        <el-table-column label="状态" align="center" width="100">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="city" label="城市" align="center" width="100"></el-table-column>
                        <el-table-column prop="region" label="城市区域" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="average_price" label="当前单价" show-overflow-tooltip>
                            <template slot-scope="s">
                                <span v-if="s.row.average_price">{{s.row.average_price}}元/㎡</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="handleCurrentChange(s.row)" plain>关联</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'TutorProject',
    data() {
        return {
            showdialog: false,
            id: '',
            form: {
                name: '',
                region: '',
                price: {
                    min: '',
                    max: '',
                }
            },
            tableData: [],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            loading: false,
        }
    },
    props: {
        regions: {
            type: Array,
            default: function(){
                return [];
            }
        },
        index: {
            type: Number,
            default: 0,
        },
        selectedCity:{
            type: String,
            default: '武汉'
        }
    },
    methods: {
        handleCurrentChange(row) {
            this.$emit('getProject', row, this.index);
            this.showdialog = false;
        },
        getTableData() {
            var region = this.form.region;
            if (typeof region == 'object' && region != ""){
                region = region[1]+'-'+region[2];
            }else{
                region = "";
            }
            var params = {
                name: this.form.name,
                region,
                price: JSON.stringify(this.form.price),
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                city: this.selectedCity,
            };
            this.$api.getProjectList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>

</style>